/* eslint-disable */
import $ from 'jquery';

const SELECTORS = {
  FOLLOWED: {
    CONTAINER: '.cards--shops',
  },
  RECOMMENDED: {
    CONTAINER: '.recommended-shops',
  },
  CPL: {
    CONTAINER: '.action-button--shops-cpl',
  },
  HOT_LIST: {
    CONTAINER: '.hotlist-shops',
  },
};

function handleFollowButtonClick() {
  const $followButton = $(this);

  if (!$followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
    $followButton.prop('disabled', true);
    const $returnFocus = $('[id*=recommended-shop-heading]:first .link');
    const data = $.param({
      cplId: $followButton.data('cpl-id'),
      operation: window.rcProps.myShops.myShopAddOperation,
    });
    $.ajax({
      url: window.rcProps.myShops.updateMyShopPath,
      type: 'post',
      data: data,
      success: function () {
        $.modal({
          open: "my-shop-add-confirm-modal",
          type: 'notification',
          triggerOpen: true,
          returnFocus: $returnFocus.length ? $returnFocus : '',
          closeButton: false,
        });
        $followButton.closest('li').delay(800).remove();
        location.reload();
      }
    });
  }
}

function handleUnfollowButtonClick() {
  const $unfollowButton = $(this);
  const data = $.param({
    cplId: $unfollowButton.data('cpl-id'),
    operation: window.rcProps.myShops.myShopRemoveOperation,
  });
  $unfollowButton.closest('li').delay(800).remove();
  $.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function () {
      $.modal({
        open: "my-shop-remove-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        returnFocus: $('[id*=my-shops-heading]:last .link'),
        closeButton: false,
      });
      const totalShops = parseInt($('#shops-size').text()) - 1;
      if (totalShops >= 0) {
        $('#shops-size').text(totalShops);
      }

      const shopsSize = $('.my-favorite-shop').length;
      const url = new URL(window.location.href);
      if (shopsSize < 1) {
        $('.pagination__wrap').hide();
        let pageNo = url.searchParams.get('pageNum');
        if (pageNo) {
          pageNo = parseInt(pageNo) - 1;
          if (pageNo <= 1) {
            url.searchParams.delete('pageNum');
          } else {
            url.searchParams.set('pageNum', pageNo);
          }
        }
      }
      window.location.href = url.href;
    }
  });
}

function addFollowButtonListener() {
  const $followButtons = $(SELECTORS.RECOMMENDED.HEART_ICON);
  $followButtons.each(function addFollow() {
    const $followButton = $(this);
    $followButton.on('click', handleFollowButtonClick);
  });
}

function addUnfollowButtonListener() {
  const $unfollowButtons = $(SELECTORS.FOLLOWED.HEART_ICON);
  $unfollowButtons.each(function addUnfollow() {
    const $unfollowButton = $(this);
    $unfollowButton.on('click', handleUnfollowButtonClick);
  });
}

function addHotlistHeartButtonListener() {
  const $heartButtons = $(SELECTORS.HOT_LIST.HEART_ICON);
  $heartButtons.each(function addUnfollow() {
    const $heartButton = $(this);
    $heartButton.on('click', handleHeartButtonClick);
  });
}

function handleHeartButtonClick() {
  const $heartButton = $(this);
  if (!$heartButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    addHearted($heartButton);
  } else {
    removeHearted($heartButton);
  }
}

function addHearted($followButton) {
  const data = $.param({
    cplId: $followButton.data('cpl-id'),
    operation: window.rcProps.myShops.myShopAddOperation,
  });
  if ($followButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    return;
  }
  $followButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
  $.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function () {
      $.modal({
        open: "my-shop-add-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        closeButton: false,
      });
    }
  });
}

function removeHearted($unfollowButton) {
  const data = $.param({
    cplId: $unfollowButton.data('cpl-id'),
    operation: window.rcProps.myShops.myShopRemoveOperation,
  });
  if (!$unfollowButton.hasClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS)) {
    return;
  }
  $unfollowButton.toggleClass(SELECTORS.RECOMMENDED.ACTIVE_CLASS);
  $.ajax({
    url: window.rcProps.myShops.updateMyShopPath,
    type: 'post',
    data: data,
    success: function () {
      $.modal({
        open: "my-shop-remove-confirm-modal",
        type: 'notification',
        triggerOpen: true,
        closeButton: false,
      });
    }
  });
}

$(() => {
  // Execute only if at least one of the container elements exists
  if ($(SELECTORS.FOLLOWED.CONTAINER).length || $(SELECTORS.RECOMMENDED.CONTAINER).length || $(SELECTORS.HOT_LIST.CONTAINER).length) {
    SELECTORS.RECOMMENDED.HEART_ICON = `${SELECTORS.RECOMMENDED.CONTAINER}__favorite`;
    SELECTORS.RECOMMENDED.ACTIVE_CLASS = 'recommended-shops__favorite--active';
    SELECTORS.FOLLOWED.CARD_CONTAINER = '.card--shops';
    SELECTORS.FOLLOWED.HEART_ICON = `${SELECTORS.FOLLOWED.CARD_CONTAINER}__header-icon`;
    SELECTORS.HOT_LIST.HEART_ICON = `${SELECTORS.HOT_LIST.CONTAINER}__favorite`;

    addFollowButtonListener();
    addUnfollowButtonListener();
    addHotlistHeartButtonListener();
  } else if ($(SELECTORS.CPL.CONTAINER).length) {
    SELECTORS.CPL.ACTIVE_CLASS = 'action-button--shops-cpl--active';

    $(SELECTORS.CPL.CONTAINER).on('click', function toggleFavorite() {
      const $heartButton = $(this);

      if (!$heartButton.hasClass(SELECTORS.CPL.ACTIVE_CLASS)) {
        $heartButton
            .toggleClass(SELECTORS.CPL.ACTIVE_CLASS)
            .addClass('action-button--dark')
            .find('.favorite-msg')
            .text('Following This Shop');
        const data = $.param({
          cplId: $heartButton.data('cpl-id'),
          operation: window.rcProps.myShops.myShopAddOperation,
        });
        $.ajax({
          url: window.rcProps.myShops.updateMyShopPath,
          type: 'post',
          data: data,
          success: function () {
            $.modal({
              open: 'add-my-shop-confirm-modal',
              type: 'notification',
              triggerOpen: true,
              returnFocus: SELECTORS.CPL.CONTAINER,
              closeButton: false,
            });
          }
        });
      } else {
        $heartButton
            .toggleClass(SELECTORS.CPL.ACTIVE_CLASS)
            .removeClass('action-button--dark')
            .find('.favorite-msg')
            .text('Follow This Shop');

        const data = $.param({
          cplId: $heartButton.data('cpl-id'),
          operation: window.rcProps.myShops.myShopRemoveOperation,
        });
        $.ajax({
          url: window.rcProps.myShops.updateMyShopPath,
          type: 'post',
          data: data,
          success: function () {
            $.modal({
              open: 'remove-my-shop-confirm-modal',
              type: 'notification',
              triggerOpen: true,
              returnFocus: SELECTORS.CPL.CONTAINER,
              closeButton: false,
            });
          }
        });
      }
    });
  }
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/abtest/follow-shops.js